export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const STORYBLOK_BASE_URL = process.env.NEXT_PUBLIC_STORYBLOK_BASEURL;
export const IMAGE_CRM_BASE_URL = process.env.NEXT_PUBLIC_IMAGE_CRM_BASE_URL;
export const { NEXT_PUBLIC_COUNTRY_STATE_CITY_URL } = process.env;
